import type { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'

import type { ActionContext } from 'vuex'
import type { FeatureIdEnum } from '../../../enums'
import type { ActionClass, CrudState, TaggingActionPayload } from '../../../models'

import type { ContextProvider } from '../../../providers'

import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'

import { TAGGING_CONSTS } from '../../../store/tagging/tagging.consts'

import { TaggingUtils } from '../../../utils'

export class TagAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch }: ActionContext<CrudState, any>,
    payload: { featureId: FeatureIdEnum; type: EngagementActionsTypeEnum },
  ): Promise<void> {
    const { domain } = CONTAINER.get<ContextProvider>(TYPES.ContextProvider)()
    const taggingPayload: TaggingActionPayload = {
      ...TaggingUtils.getTaggingPayload(payload.featureId, domain),
      type: payload.type,
    }
    if (taggingPayload) {
      await dispatch(
        `${TAGGING_CONSTS.moduleName}/${TAGGING_CONSTS.actions.tagAction}`,
        taggingPayload,
        { root: true },
      )
    }
  }
}
